/* tslint:disable */
/* eslint-disable */
/**
 * AgentAssistService
 * Agent Assist API
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { AnalyticsAggrQuestionsScore } from './AnalyticsAggrQuestionsScore';
import {
    AnalyticsAggrQuestionsScoreFromJSON,
    AnalyticsAggrQuestionsScoreFromJSONTyped,
    AnalyticsAggrQuestionsScoreToJSON,
} from './AnalyticsAggrQuestionsScore';

/**
 * Extends outputs for "list" type operations to return pagination details
 * @export
 * @interface GetAnalyticsAggregationQuestionsScoreResponseContent
 */
export interface GetAnalyticsAggregationQuestionsScoreResponseContent {
    /**
     * Pass this in the next request for another page of results
     * @type {string}
     * @memberof GetAnalyticsAggregationQuestionsScoreResponseContent
     */
    nextToken?: string;
    /**
     * Map of QAAnalytics in JSON format
     * @type {Array<AnalyticsAggrQuestionsScore>}
     * @memberof GetAnalyticsAggregationQuestionsScoreResponseContent
     */
    analytics: Array<AnalyticsAggrQuestionsScore>;
}


/**
 * Check if a given object implements the GetAnalyticsAggregationQuestionsScoreResponseContent interface.
 */
export function instanceOfGetAnalyticsAggregationQuestionsScoreResponseContent(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "analytics" in value;

    return isInstance;
}

export function GetAnalyticsAggregationQuestionsScoreResponseContentFromJSON(json: any): GetAnalyticsAggregationQuestionsScoreResponseContent {
    return GetAnalyticsAggregationQuestionsScoreResponseContentFromJSONTyped(json, false);
}

export function GetAnalyticsAggregationQuestionsScoreResponseContentFromJSONTyped(json: any, ignoreDiscriminator: boolean): GetAnalyticsAggregationQuestionsScoreResponseContent {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'nextToken': !exists(json, 'nextToken') ? undefined : json['nextToken'],
        'analytics': ((json['analytics'] as Array<any>).map(AnalyticsAggrQuestionsScoreFromJSON)),
    };
}

export function GetAnalyticsAggregationQuestionsScoreResponseContentToJSON(value?: GetAnalyticsAggregationQuestionsScoreResponseContent | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'nextToken': value.nextToken,
        'analytics': ((value.analytics as Array<any>).map(AnalyticsAggrQuestionsScoreToJSON)),
    };
}

